import { Component } from '@angular/core';

import { SwitchCase } from '@pwp-common';

import { ObjListEditor } from '../../../../generic/abstract-classes/obj-list-editor';

@Component({
  selector: 'app-switch-case-select-and-edit',
  templateUrl: './switch-case-select-and-edit.component.html',
  styleUrls: ['./switch-case-select-and-edit.component.css'],
})
export class SwitchCaseSelectAndEditComponent extends ObjListEditor<SwitchCase> {
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Validation
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  objBuilder() {
    return SwitchCase.deserialize({});
  }

  isValidList(): boolean {
    // This checks that the form is valid.
    if (!super.isValidList()) {
      return false;
    }

    if (this.objList.length === 0) {
      return false;
    }

    return true;
  }
}
